import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GeneralAdminStore } from './general-admin.store';
import { UnitOfMeasureDto } from '../../core/models/unit-of-measure-dto';
import { CurrencyService } from '../../core/services/currency.service';
import { OrganisationsService } from '../../core/services/organisations.service';
import { UnitOfMeasureService } from '../../core/services/unit-of-measure.service';

@Injectable({ providedIn: 'root' })
export class GeneralAdminService {
  constructor(
    private store: GeneralAdminStore,
    private organisationsService: OrganisationsService,
    private currencyService: CurrencyService,
    private unitOfMeasureService: UnitOfMeasureService,
  ) {}

  setOrganisations() {
    this.organisationsService.get().subscribe((data) => this.store.setOrganisations(data));
  }

  getUnitOfMeasure(): Observable<UnitOfMeasureDto[]> {
    return this.unitOfMeasureService.get().pipe(
      tap((value) => {
        this.store.setUnitOfMeasure(value);
      }),
    );
  }

  getCurrencies(): Observable<string[]> {
    return this.currencyService.get().pipe(
      tap((value) => {
        this.store.setCurrencies(value);
      }),
    );
  }
}
